import { useState } from "react";
import { classNames as cn } from "tools/ui";
const BASE_STYLE = "w-full h-full object-cover transition-opacity duration-500";
const IMAGE_DEFAULT =
  "https://www.shutterstock.com/image-vector/image-icon-600nw-211642900.jpg";

const ImagePerfil = ({ src, alt = "", className = "", onClick, height }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative w-full h-20 md:h-full overflow-hidden rounded-md">
      {!loaded && (
        <div className="absolute inset-0 bg-gray-200 animate-pulse flex justify-center items-center">
          <svg
            className="size-8 animate-spin text-secundary mx-auto w-auto"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              className="opacity-75 text-[#00545f]"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
      )}

      <img
        src={src || IMAGE_DEFAULT}
        alt={alt}
        className={cn(BASE_STYLE, !loaded && "opacity-0", className, height)}
        onLoad={() => setLoaded(true)}
        onClick={onClick}
      />
    </div>
  );
};

export default ImagePerfil;
